import { Component, OnInit } from '@angular/core';
import { CaseManagementService } from 'src/app/core/services/v2/case-management.service';
import { UserService } from 'src/app/core/services/v2/user.service';
import { PhysicianOptionService } from 'src/app/physician/shared/physician-option/physician-option.service';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';

@Component({
  selector: 'casemanager-dashboard',
  templateUrl: './casemanager-dashboard.component.html',
  styleUrls: ['./casemanager-dashboard.component.scss']
})
export class CasemanagerDashboardComponent implements OnInit {
  totalCasesForDashboard:any;
  caselistBystatus:any
  constructor(private caseManagementService: CaseManagementService,
    private userService:UserService,
    private physicianOptionService: PhysicianOptionService,
    private loaderService: WindowLoaderService,) { }

  ngOnInit() {
    this.physicianOptionService.selectionChange$.subscribe(
      (_) => {
        this.getTotalCasesForDashboard();
        this.getCases();
      },
      (error) => {
        console.error(error);
      }
    );
   
  }
  getTotalCasesForDashboard() {
    this.loaderService.show();
    this.caseManagementService
      .getTotalCasesForDashboard( this.physicianOptionService.getPhysician().userId    
      )
      .subscribe((res) => {
        this.totalCasesForDashboard=res.result;
        this.loaderService.hide();

      }, (error) => {
        console.error(error);
        this.loaderService.hide();
      },
      () => {
        this.loaderService.hide();
      });
  }
  getCases() {
    this.loaderService.show();
    this.caseManagementService
      .getCases( this.physicianOptionService.getPhysician().userId    
      )
      .subscribe((res) => {
        this.caselistBystatus=res.result;
        this.loaderService.hide();

      }, (error) => {
        console.error(error);
        this.loaderService.hide();
      },
      () => {
        this.loaderService.hide();
      });
  }
  
}
